import React from 'react'
import style from './style'
import injectSheet from 'react-jss'

class Locked extends React.Component {
  render() {
    const { classes } = this.props
    return (
      <div>
        <p>This project has been updated on another device.</p>
        <p>Please reload the page to get the most up to date version of your work.</p>
        <button
          className={classes.lockedButton}
          onClick={_ => window.location.reload()}
        >
          Reload
        </button>
      </div>
    )
  }
}

export const LockedConfig = { title: 'Project Locked', hideClose: true }
export default injectSheet(style)(Locked)



// WEBPACK FOOTER //
// ./src/components/Locked/index.js